import { AxiosConfig, getP44Env } from '@project44/ui-utils';
import { DtoBase, TenantModels } from '@project44-models/iam-gateway';

const { PUBLIC_API_BASE_URL } = getP44Env();

export class TenantCredentialsUpdaterLegacy {
  public static readonly PUBLIC_API_BASE_URL = PUBLIC_API_BASE_URL;

  public readonly composeRequestConfig = async (payload: {
    tenant: DtoBase<TenantModels.TenantViewModel>;
    tenantCredentials: File;
  }): Promise<AxiosConfig> => {
    const { tenantCredentials, tenant } = payload;
    const tenantId = tenant.source.getTenantId();

    return {
      baseURL: TenantCredentialsUpdaterLegacy.PUBLIC_API_BASE_URL,
      withCredentials: true,
      url: `${this.fhCustomerControllerPath}/import-credentials/${tenantId}`,
      method: 'POST',
      data: await this.convertFileToBase64({ tenantCredentials }),
      headers: {
        Accept: 'application/json;q=0.8,application/signed-exchange;v=b3;q=0.9',
        'Content-Type': 'text/plain',
      },
    };
  };

  public readonly convertFileToBase64 = async (payload: {
    tenantCredentials: File;
  }): Promise<string> => {
    const fileReader = new FileReader();

    return new Promise((resolve, reject) => {
      fileReader.onload = (): void => {
        try {
          resolve(this.handleBase64Results(fileReader.result));
        } catch (e) {
          reject(e);
        }
      };

      fileReader.readAsDataURL(payload.tenantCredentials);
    });
  };

  public readonly handleBase64Results = (
    convertedFile: ArrayBufferLike | string | null,
  ): string => {
    if (typeof convertedFile === 'string') {
      return convertedFile;
    }
    if (convertedFile === null) {
      return '';
    }
    return String.fromCharCode.apply(null, [
      Number(new Uint16Array(convertedFile)),
    ]);
  };

  public static readonly compose = async (payload: {
    tenant: DtoBase<TenantModels.TenantViewModel>;
    tenantCredentials: File;
  }): Promise<AxiosConfig> => {
    return new TenantCredentialsUpdaterLegacy().composeRequestConfig(payload);
  };

  private readonly fhCustomerControllerPath = `/portal/admin/customers`;
}
